/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_EmptyInputs */

const en_pb_empty = /** @type {(inputs: Pb_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No playbook to show yet.`)
};

const id_pb_empty = /** @type {(inputs: Pb_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada playbook yang bisa ditampilkan.`)
};

/**
* | output |
* | --- |
* | "No playbook to show yet." |
*
* @param {Pb_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_empty = /** @type {((inputs?: Pb_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_empty(inputs)
	return en_pb_empty(inputs)
});